import React, { useState } from 'react'
import { Modal, Radio } from 'antd'

const DuplicateShotModal = ({ visible, shotIndex, onCancel, onConfirm }) => {
  const [position, setPosition] = useState('after')

  return (
    <Modal
      maskClosable={false}
      title="Duplicate Shot"
      visible={visible}
      onCancel={onCancel}
      onOk={() => onConfirm(position)}
      okText="Confirm"
      centered
    >
      <p style={{ marginBottom: 16 }}>
        This will add a new duplicate shot of the current shot (Shot {shotIndex}).
        Where would you like to place the new shot in the scene?
      </p>
      <Radio.Group 
        onChange={(e) => setPosition(e.target.value)} 
        value={position}
        style={{ display: 'flex', flexDirection: 'column', gap: 10 }}
      >
        <Radio value="before">Before this shot</Radio>
        <Radio value="after">After this shot</Radio>
      </Radio.Group>
    </Modal>
  )
}

export default DuplicateShotModal
